import { API_BASE_URL } from '../../constants/appConstants';
import { authenticatedRequest } from '../authService';

const SUPERADMIN_BASE_URL = `${API_BASE_URL}/superadmin`;

/**
 * Fetch superadmin profile data
 * @returns {Promise<Object>} Response with profile data
 */
export const fetchProfile = async () => {
  const url = `${SUPERADMIN_BASE_URL}/settings/profile/`;

  try {
    const response = await authenticatedRequest(url, {
      method: 'GET',
    });

    if (!response.success) {
      throw new Error(response.error || 'Failed to fetch profile');
    }

    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Error fetching profile:', error);
    throw new Error(error.message || 'Failed to fetch profile');
  }
};

/**
 * Update superadmin profile
 * @param {Object} profileData - Profile data to update
 * @returns {Promise<Object>} Response with updated profile data
 */
export const updateProfile = async (profileData) => {
  const url = `${SUPERADMIN_BASE_URL}/settings/profile/`;

  try {
    const response = await authenticatedRequest(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(profileData),
    });

    if (!response.success) {
      throw new Error(response.error || 'Failed to update profile');
    }

    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Error updating profile:', error);
    throw new Error(error.message || 'Failed to update profile');
  }
};

/**
 * Fetch app settings
 * @returns {Promise<Object>} Response with app settings data
 */
export const fetchAppSettings = async () => {
  const url = `${SUPERADMIN_BASE_URL}/settings/app/`;

  try {
    const response = await authenticatedRequest(url, {
      method: 'GET',
    });

    if (!response.success) {
      throw new Error(response.error || 'Failed to fetch app settings');
    }

    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Error fetching app settings:', error);
    throw new Error(error.message || 'Failed to fetch app settings');
  }
};

/**
 * Update app settings
 * @param {Object} settingsData - App settings data to update
 * @returns {Promise<Object>} Response with updated app settings data
 */
export const updateAppSettings = async (settingsData) => {
  const url = `${SUPERADMIN_BASE_URL}/settings/app/`;

  try {
    const response = await authenticatedRequest(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(settingsData),
    });

    if (!response.success) {
      throw new Error(response.error || 'Failed to update app settings');
    }

    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Error updating app settings:', error);
    throw new Error(error.message || 'Failed to update app settings');
  }
};

/**
 * Fetch public app settings (for welcome page)
 * @returns {Promise<Object>} Response with public app settings data
 */
export const fetchPublicAppSettings = async () => {
  const url = `${SUPERADMIN_BASE_URL}/settings/public/`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to fetch public app settings');
    }

    return {
      success: true,
      data: data
    };
  } catch (error) {
    console.error('Error fetching public app settings:', error);
    // Return default values on error
    return {
      success: true,
      data: {
        contact_email: 'callcenter@ngombe.org',
        contact_phone: '+237 652 751 999',
        contact_address: 'Cameroon',
        has_settings: false
      }
    };
  }
};